export default "__VITE_ASSET__a8e73a94__"